import { FC } from "react";
import clsx from "clsx";
import Header from "./header";
import Sidebar from "./sidebar";
import { ScrollBar } from "@ht/components";
import SEO from "../../components/seo";

interface IProps {
    containerClass?: string;
    showSidebar: boolean;
}

const Layout: FC<IProps> = ({ children, showSidebar }) => {
    return (
        <>
            <SEO />
            <Header />
            <div className="relative bg-white flex h-[calc(100vh-54px)]">
                <aside
                    className={clsx("h-full", {
                        hidden: !showSidebar,
                    })}
                >
                    <Sidebar />
                </aside>
                <main className={clsx("h-full flex-auto")}>
                    <ScrollBar>{children}</ScrollBar>
                </main>
            </div>
        </>
    );
};

export default Layout;
